import BloomreachAssets from '@mediashop/base/pattern/atom/BloomreachAssets';
import BackgroundColorWrapper from '@mediashop/base/pattern/atom/BackgroundColorWrapper';
import ContentWrapper from '@mediashop/base/pattern/atom/ContentWrapper';
import classNames from 'classnames';
import { BrXImageVariant } from '@mediashop/base/types/imageVariants';
import { EMPTY_STRING, SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import { FlexboxProps } from './index';
import { LinkOpenInTab } from '@mediashop/base/pattern/atom/LinkOpenInTab';
import Headlines from '@mediashop/base/pattern/atom/Headlines';

const componentName = 'flexbox';

const requiredLargeBoxes = {
    1: 1,
    2: 0,
    3: 1,
    4: 2,
    5: 1,
    6: 2,
    7: 3,
    8: 4,
    9: 3,
    10: 4,
    11: 3,
};

const getAdjustedItems = (items: FlexboxProps['items']) => {
    let missingLargeBoxes = requiredLargeBoxes[items.length] - items.filter((item) => item.size === 'large').length;
    if (missingLargeBoxes <= 0) {
        return items;
    }
    return items.map((item) => {
        const newItem = item;
        if (missingLargeBoxes > 0 && item.size !== 'large') {
            newItem.size = 'large';
            missingLargeBoxes--;
        }
        return newItem;
    });
};

function Flexbox({ background, headline, items }: FlexboxProps): JSX.Element {
    const adjustedItems = getAdjustedItems(items);
    return (
        <BackgroundColorWrapper backgroundColor={background.color}>
            <ContentWrapper>
                <div className={componentName}>
                    <Headlines {...headline} />

                    <div
                        className={classNames(
                            `${componentName}-container`,
                            `${componentName}-container--grid-${items.length}`
                        )}
                    >
                        {adjustedItems.map((item, index) => (
                            <LinkOpenInTab
                                link={item.ctaButton}
                                tab={item.ctaTarget}
                                key={index}
                                className={classNames(
                                    `${componentName}-box`,
                                    item.size === 'large' ? `${componentName}-box--big` : `${componentName}-box--small`
                                )}
                            >
                                <BloomreachAssets
                                    className={`${componentName}-box`}
                                    altText={item.image.altText ?? EMPTY_STRING}
                                    desktopImage={item.image}
                                    variant={BrXImageVariant.FlexBox}
                                />

                                {item.ctaButton.text ? (
                                    <span
                                        className={`${componentName}-box__btn`}
                                        style={{
                                            color: item.ctaButton.fontColorHex
                                                ? item.ctaButton.fontColorHex
                                                : undefined,
                                            background: item.ctaButton.backgroundColorHex
                                                ? item.ctaButton.backgroundColorHex
                                                : undefined,
                                        }}
                                    >
                                        {item.ctaButton.text}
                                    </span>
                                ) : (
                                    SKIP_RENDER
                                )}
                            </LinkOpenInTab>
                        ))}
                    </div>
                </div>
            </ContentWrapper>
        </BackgroundColorWrapper>
    );
}

export default Flexbox;
